/*
 * useWindowDimensions React Hook
 *
 * Ref: https://usehooks.com
 * Ref: https://joshwcomeau.com/react/the-perils-of-rehydration
 *
 */

import { useState, useEffect } from "react"

const isBrowser = typeof window !== "undefined"

export const useWindowDimensions = () => {
  // Initialize state with undefined width/height so server and client renders match
  const [windowDimensions, setWindowDimensions] = useState({
    width: undefined,
    height: undefined,
  })

  useEffect(() => {
    // If window is defined
    if (isBrowser) {
      // Handle window resize
      function handleResize() {
        // Set window width/height in state
        setWindowDimensions({
          width: window.innerWidth,
          height: window.innerHeight,
        })
      }

      // Add event listener
      window.addEventListener("resize", handleResize)

      // Call handler right away so state gets updated with initial window size
      handleResize()

      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize)

      // Else if window is not defined return null
    } else {
      return () => null
    }
  }, []) // Empty array ensures that effect is only run on mount
  return windowDimensions
}
